module.exports = __webpack_public_path__ + "static/img/banner.18a36fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/banner.png
// module id = VIw5
// module chunks = 3